import React from "react";
import "./WhatsAppButton.css";

function WhatsAppButton() {
  const phoneNumber = "919610071616"; // +91 96100 71616 in international format without + or spaces
  const message = "Hello, I would like to inquire about your construction services.";
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappURL}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className="whatsapp-icon"
      >
        <path
          fill="currentColor"
          d="M16 0C7.164 0 0 7.164 0 16c0 2.832.744 5.488 2.048 7.792L0 32l8.416-2.208A15.936 15.936 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.344c-2.56 0-5.024-.744-7.072-2.048l-.512-.304-5.312 1.392 1.408-5.12-.336-.528A13.248 13.248 0 0 1 2.656 16c0-7.36 5.984-13.344 13.344-13.344S29.344 8.64 29.344 16 23.36 29.344 16 29.344z"
        />
        <path
          fill="currentColor"
          d="M23.616 19.36c-.416-.208-2.448-1.216-2.832-1.344-.384-.144-.656-.208-.944.208-.272.416-1.088 1.344-1.328 1.616-.24.288-.496.32-.912.112-.416-.208-1.76-.656-3.36-2.08-1.232-1.104-2.064-2.48-2.304-2.896-.24-.416-.016-.64.176-.848.192-.192.416-.496.624-.752.208-.24.288-.416.432-.688.144-.288.08-.528-.016-.752-.096-.208-.944-2.272-1.296-3.104-.336-.8-.688-.688-.944-.688-.24-.016-.528-.016-.8-.016s-.736.096-1.12.528c-.384.416-1.472 1.44-1.472 3.52s1.504 4.08 1.712 4.368c.208.272 2.944 4.48 7.12 6.272.992.432 1.776.688 2.384.88.992.32 1.904.272 2.624.16.8-.128 2.448-1.008 2.8-1.968.352-.976.352-1.808.24-1.984-.096-.192-.368-.288-.784-.496z"
        />
      </svg>
    </a>
  );
}

export default WhatsAppButton;
